// Presenter helpers shared by <lp-presenter-list> and <lp-faculty-detail>.
//
// The backend (ConferenceLandingPageService::transformPresenterForNewTheme)
// sends id/_id/name/role/photo/bio only — no initials and no avatar gradient —
// so both are derived here rather than duplicated per surface.

/**
 * Up to two leading letters of a name, used when a presenter has no photo.
 * Words that do not start with a letter (credentials like "PT, DPT") are
 * skipped so "Benjamin Gelfand, PT, DPT" yields "BG", not "BP".
 */
export function initials(name) {
  const letters = String(name || '')
    .split(/\s+/)
    .filter((word) => /^[A-Za-z]/.test(word))
    .map((word) => word[0])
    .slice(0, 2)
    .join('');

  return letters.toUpperCase() || '••';
}

/**
 * Stable brand-tinted gradient for a photo-less avatar. The hue offset is
 * derived from the name so the same presenter keeps the same tint across the
 * landing page and the registration page.
 */
export function avatarGradient(name) {
  const seed = String(name || '')
    .split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);

  return `linear-gradient(135deg, var(--brand) 0%, var(--brand-light) 100%)`
    .replace('135deg', `${(seed % 8) * 15 + 110}deg`);
}
